import React, { useState } from 'react'
import { Col, Form, FormInstance, Input, Row } from 'antd'
import { energyLevelStore } from 'state/listing/energyLevel'
import { myStore } from 'state/store'
import { Photo } from 'types/globalTypes'
import UploadDocument from 'components/global/UploadDocument'
import {
  useCreateEnergyLevel,
  useUpdateEnergyLevel,
} from 'api/Listings/EnergyLevel'

interface EnergyLevelFormProps {
  form: FormInstance
}

const EnergyLevelForm: React.FC<EnergyLevelFormProps> = ({ form }) => {
  const { setEnergyLevelModal, energyLevelData } = energyLevelStore(store => ({
    setEnergyLevelModal: store.setEnergyLevelModal,
    energyLevelData: store.energyLevelData,
  }))
  const setModalBtnLoading = myStore(store => store.setModalBtnLoader)

  const [error, setError] = useState<string>('')
  const [documentIds, setDocumentIds] = useState<string[]>(
    energyLevelData ? [energyLevelData.iconId] : [],
  )
  const [photos] = useState<Photo[]>(
    energyLevelData ? [energyLevelData.icon] : [],
  )

  const formSchema = {
    name: energyLevelData ? energyLevelData.name : undefined,
  }
  const { mutate: createItemToBring } = useCreateEnergyLevel()
  const { mutate: updateItemToBring } = useUpdateEnergyLevel()

  const onFinish = (values: { name: string; color: string }) => {
    if (documentIds.length === 0) {
      setError('Icons is required')
      return
    }
    const payload = {
      ...values,
      iconId: documentIds[0],
    }
    setModalBtnLoading(true)
    if (energyLevelData) {
      updateItemToBring(
        { energyLevelId: energyLevelData._id, payload },
        {
          onSuccess: () => {
            setModalBtnLoading(false)
            setEnergyLevelModal(false)
          },
          onError: () => {
            setModalBtnLoading(false)
          },
        },
      )
    } else {
      createItemToBring(payload, {
        onSuccess: () => {
          setModalBtnLoading(false)
          setEnergyLevelModal(false)
        },
        onError: () => {
          setModalBtnLoading(false)
        },
      })
    }
  }

  return (
    <>
      <Form
        name="items-to-bring-form"
        form={form}
        initialValues={formSchema}
        onFinish={onFinish}
        layout="vertical"
        autoComplete="off"
      >
        <Row>
          <Col>
            <label className="custom-field-label required-input">
              Add Icon
            </label>
          </Col>
          <Col span={12}>
            <UploadDocument
              documentIds={documentIds}
              setDocumentIds={setDocumentIds}
              multiple={true}
              docType="image/*"
              files={photos}
            />
          </Col>
          {error && (
            <Col className="-mt-20px" span={24}>
              <p className="ant-form-item-explain-error">{error}</p>
            </Col>
          )}
        </Row>
        <Row className="-mt-10px">
          <Col span={24}>
            <label className="input-label required-input">Name</label>
            <Form.Item
              colon={false}
              name="name"
              rules={[{ required: true, message: 'Name is required' }]}
            >
              <Input placeholder="Enter Name" required name="name" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default EnergyLevelForm
